"use strict"
import {useFetch} from "@vueuse/core";
import {maybeEnableJumpToTop} from "@/modules/jumpToTop.js";

const masterDebug = false;

// Determine base URL based on current hostname
function getBaseUrl() {
  if (typeof window === 'undefined') return 'http://yummi.yoav:3000/';
  
  const hostname = window.location.hostname;
  
  if (hostname === 'newstage.yummi.co.il') {
    return 'https://newstage.yummi.co.il:443/';
  } else if (hostname === 'staging.yummi.co.il') {
    return 'https://staging.yummi.co.il:443/';
  } else if (hostname === 'www.yummi.co.il' || hostname === 'yummi.co.il') {
    return 'https://legacy.yummi.co.il:443/';
  }
  
  // Default for local development
  return 'http://yummi.yoav:3000/';
}

const _configuration = {
    baseUrl: getBaseUrl(),
    // baseUrl: 'http://staging.yummi.co.il:8080/',
    //baseUrl: 'https://staging.yummi.co.il:443/',
    // baseUrl: 'http://localhost:3000/',
    // baseUrl: 'http://yummi.yoav:3000/',
    // baseUrl: 'https://legacy.yummi.co.il:443/',
    // Grow Wallet SDK — must match Meshulam env for this deploy (same as backend createPaymentProcess).
    // growSdkEnvironment: 'DEV',
    growSdkEnvironment: 'PRODUCTION',
    defaultHeaders: {
        Accept: 'application/json',
        //Authorization: 'Basic eXVtbWk6eTEyMzQ1'
    }
};

async function _fetch3($this, obj) {
    let link = '';
    const url = obj.url;
    const method = obj.method || "get";
    if (url) {
        link = url[0] == '/' ? url.substring(1) : url; //remove first /
    }
    if (obj.addQueryString) {
        const query = $this.$route.query;
        let queryStringArr = [];
        for (const param in query) {
            queryStringArr.push(param + "=" + encodeURIComponent(query[param]));
        }
        link += (link.indexOf("?") > 0 ? "&" : "?") + queryStringArr.join("&");
    }
    if (obj.queryString) {
        link += (link.indexOf("?") > 0 ? "&" : "?") + obj.queryString;
    }
    // link = link.replace(/&&+/, "&").replace(/&=/, '=');
    if (obj.pushHistory) {
        const firstSlash = link.indexOf("/", 5);
        const addToHistoryPath = link.substring(firstSlash);
        history.pushState({}, null, addToHistoryPath);
        // console.log("add to history: " + addToHistoryPath);
    }
    try {
        let response = await fetch((configuration.baseUrl + link), {
            method: method,
            redirect: "manual",
            credentials: 'include',
            headers: {
                Accept: 'application/json'
            },
            body: obj.body
        });
        if (response.status == 404) {
            const d = await response.json();
            if ($this?.$router) {
                $this.$router.push({name: 'not_found', params: {d: JSON.stringify(d)}});
            }
            return {};
        } else if (response.status != 200) {
            const d = await response.json();
            if ($this?.$router) {
                $this.$router.push({name: 'e500', params: {d: JSON.stringify(d)}});
            }
            return {};
        }
        let data = await response.json();
        if (handleRedirect(data)) {
            return {};
        }
        if ($this?.$store) {
            if (data?.popup?.prompt_json) {
                $this.$store.dispatch('showPopup', data.popup.prompt_json.popup_content);
            }
            maybeEnableJumpToTop($this.$store, link, data);
        }
        return data;
    } catch (e) {
        if ($this?.$router) {
            $this.$router.push({name: 'e500', params: {d: JSON.stringify({title: 'oops'})}});
        }
        return {};
    }
}

async function _fetch2($this, url, method) {
    return await _fetch3($this,
        {
            url: url,
            method: method
        });
}

//todo: remove?
async function _fetch2Ref(urlRef) {
    return useFetch(urlRef, {
        async beforeFetch({url, options/*, cancel*/}) {
            if (masterDebug) {
                console.log('fetch2: ' + url);
            }
            options.headers = {
                ...options.headers,
                ...configuration.defaultHeaders
            }
            options.credentials = 'include';
            options.refetch = true;
            return {
                options,
            }
        },
    }).get().json();
}

function setFieldInvalid(fieldName, isInvalid) {
    const invalidEl = document.getElementById(fieldName + 'invalid');
    if (invalidEl) {
        if (isInvalid) {
            invalidEl.classList.add('show');
        } else {
            invalidEl.classList.remove('show');
        }
    }
    const candidates = [
        document.getElementById(fieldName),
        ...document.querySelectorAll(`input[name="${fieldName}"], select[name="${fieldName}"], textarea[name="${fieldName}"]`),
    ].filter(Boolean);
    const seen = new Set();
    for (const elm of candidates) {
        if (seen.has(elm)) continue;
        seen.add(elm);
        if (elm.type === 'hidden') {
            const wrapper = elm.closest('.form-group, .select-wrapper');
            const triggers = wrapper
                ? wrapper.querySelectorAll('.select-text-display, .select-display-clickable')
                : [];
            for (let ti = 0; ti < triggers.length; ti++) {
                const trigger = triggers[ti];
                if (isInvalid) {
                    trigger.setAttribute('aria-invalid', 'true');
                    if (invalidEl) {
                        trigger.setAttribute('aria-describedby', fieldName + 'invalid');
                    }
                } else {
                    trigger.removeAttribute('aria-invalid');
                    if (trigger.getAttribute('aria-describedby') === fieldName + 'invalid') {
                        trigger.removeAttribute('aria-describedby');
                    }
                }
            }
            continue;
        }
        if (isInvalid) {
            elm.setAttribute('aria-invalid', 'true');
            if (invalidEl) {
                elm.setAttribute('aria-describedby', fieldName + 'invalid');
            }
        } else {
            elm.removeAttribute('aria-invalid');
            if (elm.getAttribute('aria-describedby') === fieldName + 'invalid') {
                elm.removeAttribute('aria-describedby');
            }
        }
    }
}

function validateForm(form) {
    if (!form) return true;
    
    // Check if we should use custom validation with Hebrew messages
    if (form.classList.contains('needs-validation')) {
        const inputs = form.getElementsByTagName("input");
        let invalidCount = 0;
        form.dispatchEvent(new CustomEvent('yummi-validate', {
            detail: {
                markInvalid() {
                    invalidCount++;
                }
            }
        }));
        
        // Track radio button groups that need validation
        const radioGroups = {};
        for (let i = 0; i < inputs.length; i++) {
            let elm = inputs[i];
            if (elm.type == 'hidden') continue;
            
            // Skip autocomplete/datalist inputs - they will be validated separately
            if (elm.hasAttribute('list')) continue;

            if (elm.getAttribute('data-validate') === 'israeli_id' || elm.getAttribute('data-validate-on-submit') === 'true') {
                continue;
            }
            
            if (elm.required) {
                if (elm.type == 'checkbox') {
                    if (!elm.checked) {
                        setFieldInvalid(elm.name, true);
                        invalidCount++;
                    } else {
                        setFieldInvalid(elm.name, false);
                    }
                    continue;
                }
                
                // Handle radio buttons
                if (elm.type == 'radio') {
                    // Track this radio group
                    if (!radioGroups[elm.name]) {
                        radioGroups[elm.name] = {
                            required: true,
                            hasSelection: false,
                            name: elm.name
                        };
                    }
                    // Check if this radio is checked
                    if (elm.checked) {
                        radioGroups[elm.name].hasSelection = true;
                    }
                    continue;
                }
                
                const value = (elm.value || '').trim();
                if (value == '') {
                    setFieldInvalid(elm.name, true);
                    invalidCount++;
                } else {
                    setFieldInvalid(elm.name, false);
                }
            }
        }
        
        // Validate radio button groups
        for (let groupName in radioGroups) {
            const group = radioGroups[groupName];
            if (group.required && !group.hasSelection) {
                setFieldInvalid(groupName, true);
                invalidCount++;
            } else {
                setFieldInvalid(groupName, false);
            }
        }

        // multiple_selection: at least one checkbox when marked required (name ends with [])
        const multiselectRoots = form.querySelectorAll('[data-multiselect-at-least-one="1"]');
        for (let mi = 0; mi < multiselectRoots.length; mi++) {
            const root = multiselectRoots[mi];
            const cbName = root.getAttribute("data-multiselect-checkbox-name");
            const invalidId = root.getAttribute("data-multiselect-invalid-id");
            if (!cbName || !invalidId) continue;
            let anyChecked = false;
            for (let ii = 0; ii < inputs.length; ii++) {
                const el = inputs[ii];
                if (el.type !== "checkbox") continue;
                if (el.name !== cbName) continue;
                if (el.checked) {
                    anyChecked = true;
                    break;
                }
            }
            const invalidEl = document.getElementById(invalidId);
            if (invalidEl) {
                if (!anyChecked) {
                    setFieldInvalid(cbName, true);
                    invalidCount++;
                } else {
                    setFieldInvalid(cbName, false);
                }
            }
        }
        
        // Also validate select elements
        const selects = form.getElementsByTagName("select");
        for (let i = 0; i < selects.length; i++) {
            let elm = selects[i];
            if (elm.required) {
                const value = (elm.value || '').trim();
                if (value == '') {
                    setFieldInvalid(elm.name, true);
                    invalidCount++;
                } else {
                    setFieldInvalid(elm.name, false);
                }
            }
        }
        
        // Also validate textarea elements
        const textareas = form.getElementsByTagName("textarea");
        for (let i = 0; i < textareas.length; i++) {
            let elm = textareas[i];
            if (elm.required) {
                const value = (elm.value || '').trim();
                if (value == '') {
                    setFieldInvalid(elm.name, true);
                    invalidCount++;
                } else {
                    setFieldInvalid(elm.name, false);
                }
            }
        }
        
        // Validate autocomplete/datalist input fields (select_auto_complete)
        for (let i = 0; i < inputs.length; i++) {
            let elm = inputs[i];
            if (elm.type == 'hidden') continue;
            
            // Check if this is an autocomplete field (has list attribute)
            if (elm.hasAttribute('list') && elm.required) {
                const value = (elm.value || '').trim();
                const listId = elm.getAttribute('list');
                
                if (value == '') {
                    setFieldInvalid(elm.name, true);
                    invalidCount++;
                } else {
                    // Check if value matches one of the datalist options
                    const datalist = document.getElementById(listId);
                    let isValidOption = false;
                    
                    if (datalist) {
                        const options = datalist.getElementsByTagName('option');
                        for (let j = 0; j < options.length; j++) {
                            const optionValue = (options[j].value || '').trim();
                            if (optionValue === value) {
                                isValidOption = true;
                                break;
                            }
                        }
                    }
                    
                    if (!isValidOption) {
                        setFieldInvalid(elm.name, true);
                        invalidCount++;
                    } else {
                        setFieldInvalid(elm.name, false);
                    }
                }
            }
        }
        
        // Validate required hidden inputs (used by custom components like FormSelectIconLabelFieldComponent)
        for (let i = 0; i < inputs.length; i++) {
            let elm = inputs[i];
            if (elm.type == 'hidden' && elm.required) {
                // Check if there's a corresponding invalid-feedback element (indicates custom component)
                const invalidElement = document.getElementById(elm.name + "invalid");
                if (invalidElement) {
                    const value = (elm.value || '').trim();
                    if (value == '') {
                        setFieldInvalid(elm.name, true);
                        invalidCount++;
                    } else {
                        setFieldInvalid(elm.name, false);
                    }
                }
            }
        }
        
        const isValid = invalidCount == 0;
        
        // Show/hide form-level error message using the same "show" class pattern
        const formErrorElement = document.getElementById("form_submit_error");
        if (formErrorElement) {
            if (!isValid && formErrorElement.innerHTML.trim()) {
                formErrorElement.classList.add("show");
            } else {
                formErrorElement.classList.remove("show");
            }
        }
        
        return isValid;
    }
    
    // Fallback to browser validation for forms without needs-validation class
    if (!form.checkValidity()) {
        form.reportValidity();
        return false;
    }
    
    return true;
}

async function _formSubmit($this, form, action, formBody) {
    if (document.getElementById("error_message")) {
        document.getElementById("error_message").innerHTML = '';
    }
    const formValid = validateForm(form);
    if (formValid == false) return {};

    let formData = (form ? new FormData(form) : new FormData());
    if (formBody) {
        for (let k in formBody) {
            formData.append(k, formBody[k]);
        }
    }
    if (form && (form.method == 'get' || form.method == 'GET')) {
        const queryString = new URLSearchParams(formData).toString();
        const formAction = (action || form.action);
        const hasQueryString = formAction.indexOf('?') > 0;
        const url = formAction + (hasQueryString ? "&" : "?") + queryString;
        // console.log(url);

        if (url.startsWith('http://') || url.startsWith('https://')) {
          window.location.href = url; // Directly navigate to the absolute URL
        } else {
          $this.$router.push(url); // Push the relative route
        }
        return {};
    }
    let ac = _baseUrl(action || form.action);
    let response = await fetch(ac || form.action, {
        method: "post",
        redirect: "manual",
        credentials: 'include',
        headers: {
            Accept: 'application/json'
        },
        body: (form || formBody) ? formData : null
    });
    if (response.status == 404) {
        $this.$router.push('/not_found');
        return {};
    }
    if (response.status != 200) {
        $this.$router.push('/oops');
        return {};
    }
    let data = await response.json();
    if (handleRedirect(data)) {
        return {};
    }
    if (data.city_required) {
        $this.$store.dispatch('showSelectCity');
        return {};
    }

    let formErrors = data?.form?.form_errors || data[Object.keys(data)[0]]?.form_errors;

    if (data.popup_content || data?.prompt_json?.popup_content) {
        $this.$store.dispatch('showPopup', data.popup_content || data?.prompt_json?.popup_content);
      }

    if (formErrors && formErrors?.message) {
        document.getElementById("error_message").innerHTML = formErrors.message;
        // return {};
    }

    if (formErrors && data[Object.keys(data)[0]]?.form) {
        // form.classList.add('invalid');
        let respForm = data[Object.keys(data)[0]].form;
        for (let i = 0; i < respForm.fields.length; i++) {
            let field = respForm.fields[i];
            const fieldName = field["data_name"];
            let elm = document.getElementById(fieldName + 'invalid');
            if (elm) {
                if (field.error_message) {
                    elm.innerHTML = field.error_message.join('<br/>');
                    setFieldInvalid(fieldName, true);
                } else {
                    elm.innerHTML = '';
                    setFieldInvalid(fieldName, false);
                }
            }
        }
        window.scrollTo({top: 0, behavior: 'smooth'});
        return {};
    }


    return data;
}

function _baseUrl(url) {
    if (!url) return url;
    if (url.indexOf('http') == 0) {
        const {pathname, search} = new URL(url);
        return configuration.baseUrl + pathname.substring(1) + search;
    }
    if (url.indexOf('/') == 0) {
        return configuration.baseUrl + url.substring(1);
    }
    return configuration.baseUrl + url;
}

function _addGoogleAnalyticsDataLayer(dataLayer) {
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
      
      // Merge the provided dataLayer with the existing dataLayer
      if (dataLayer && typeof dataLayer === 'object') {
        if (Array.isArray(dataLayer)) {
          window.dataLayer.push(...dataLayer);
        } else {
          window.dataLayer.push(dataLayer);
        }
      }
      
      // Add Google Analytics script
      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({
          'gtm.start': new Date().getTime(),
          event: 'gtm.js'
        });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', 'GTM-5H7CHJT');
    }
  }


export function handleRedirect(data) {
    if (!data) return false;
    let parentRedirectUrl = data.redirect_parent_to || data.redirect_parent;
    if (parentRedirectUrl) {
        parent.location.href = parentRedirectUrl;
        return true;
    }
    let redirectUrl = data.redirect_to || data.redirect;
    if (redirectUrl) {
        window.location = redirectUrl;
        return true;
    }
    return false;
}

/** GET JSON without auto-redirect — for Meshulam return URLs (caller handles redirect_to). */
export async function fetchReturnJson(urlPath) {
    const link = urlPath && urlPath[0] === "/" ? urlPath.substring(1) : urlPath;
    const response = await fetch(configuration.baseUrl + link, {
        method: "GET",
        redirect: "manual",
        credentials: "include",
        headers: {
            Accept: "application/json",
        },
    });
    if (response.status === 404) {
        return { error: true, status: 404 };
    }
    if (response.status !== 200) {
        return { error: true, status: response.status };
    }
    return response.json();
}

export const configuration = _configuration;
export const growSdkEnvironment = _configuration.growSdkEnvironment;
export const fetch2 = _fetch2;
export const fetch3 = _fetch3;
export const fetch2Ref = _fetch2Ref;
export const baseUrl = _baseUrl;
export const formSubmit = _formSubmit;
export const addGoogleAnalyticsDataLayer = _addGoogleAnalyticsDataLayer;
